import { Cryptocoin } from "@models";
import { LEVERAGED_TOKEN_TYPE } from "@helpers/constants";
import { TradableDetailInterface, TradableDetailType } from "@models/interfaces/tradable_detail_types";

export class LeveragedToken extends Cryptocoin {
	protected static readonly currencyType: string = LEVERAGED_TOKEN_TYPE;
	protected readonly tradable_actions: string[] = ["buy", "sell"];
	public readonly tradableDetailLabels: TradableDetailInterface[] = [
		{
			label: "daily_high",
			translationKey: "tradable_detail_label_daily_high",
			type: TradableDetailType.FIAT
		},
		{
			label: "daily_low",
			translationKey: "tradable_detail_label_daily_low",
			type: TradableDetailType.FIAT
		},
		{
			label: "monthly_volatility",
			translationKey: "tradable_detail_label_monthly_volatility",
			type: TradableDetailType.PERCENTAGE
		},
		{
			label: "base_price",
			translationKey: "tradable_detail_label_base_price",
			type: TradableDetailType.FIAT,
			detailsKey: "tradable_detail_base_price_description"
		},
		{
			label: "effective_leverage",
			translationKey: "tradable_detail_label_leverage",
			detailsKey: "cfd_effective_leverage_description",
			type: TradableDetailType.LEVERAGE
		},
		{
			label: "overnight_fee",
			translationKey: "asset_details_overnight_fees",
			type: TradableDetailType.PERCENTAGE
		}
	];

	public getCurrencyType(): string {
		return LeveragedToken.currencyType;
	}
}
